import React from 'react';
import '../styles/App.css';

const Hero = () => {
  const heroStyle = {
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('/images/hero-bg.jpg')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
  };

  return (
    <section className="hero" style={heroStyle}>
      <div className="hero-overlay">
        <div className="container">
          <div className="hero-content">
            <h1>Comfort • Convenience • Hospitality</h1>
            <p>14 beautifully appointed rooms in the heart of Lilongwe</p>
            <div className="hero-buttons">
              <a href="#contact" className="btn-primary">Book Now</a>
              <a href="#rooms" className="btn-secondary">View Rooms</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;